import React, { useMemo } from 'react'
import { ErrorTrackingAPI, usePubSub } from '@services'
import { findGroupByJoinedName, CONNECTION_STATUS } from '@common'

const GroupConnectionStatus = ({ isAutoJoining, joinedGroupName, cafeGroups = [] }) => {
    const { connectionStatus } = usePubSub()
    const isConnected = connectionStatus === CONNECTION_STATUS.CONNECTED && joinedGroupName

    const getStatusText = () => {
        if (isAutoJoining) return 'Connecting'
        if (isConnected) return 'Connected'
        return 'Disconnected'
    }

    const getStatusColor = () => {
        if (isAutoJoining) return '#f59e0b'
        if (isConnected) return '#22c55e'
        return '#ef4444'
    }

    // Extract group name from cafeGroups based on joinedGroupName
    const displayName = useMemo(() => {
        if (!joinedGroupName) {
            return joinedGroupName
        }

        const match = findGroupByJoinedName(joinedGroupName, cafeGroups)
        return match?.name || joinedGroupName
    }, [joinedGroupName, cafeGroups])

    const statusText = getStatusText()
    const statusColor = getStatusColor()

    return (
        <div>
            <div className="mb-0">
                <p
                    color="light"
                    className="d-inline-flex align-items-center justify-content-center text-end m-0"
                    onClick={() => {
                        ErrorTrackingAPI.sendError(new Error('Joined group name clicked'), 'GroupConnectionStatus')
                    }}
                >
                    {displayName}
                </p>
            </div>
            <div className="d-flex align-items-center justify-content-end">
                <span
                    className="me-3 fw-medium"
                    style={{
                        fontSize: '1.2rem',
                        color: statusColor,
                    }}
                >
                    {statusText}
                </span>
                <span
                    title={statusText}
                    aria-label={statusText}
                    style={{
                        display: 'inline-block',
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        backgroundColor: statusColor,
                        boxShadow: '0 0 0 3px rgba(0,0,0,0.1)',
                    }}
                />
            </div>
        </div>
    )
}

export default GroupConnectionStatus
